import { getField, updateField } from 'vuex-map-fields'
import api from '@/store/api'

const state = {
	keyword: '',

	params: {
		filterBy: null,
		sortBy: null,
		page: 1,
		count: 10
	},

	isLogout: false,
	isLogin: false,
	userType: null,

	error: {
		email: '',
		password: '',
		name: '',
		weight: '',
		// age: '',
		birthday: null,
		gender: ''
	},

	loginError: null,

	routerList: {},
	bandList: {},

	listLoading: false,
	buttonLoading: false,

	userForm: {
		facebookId: '',
		name: '',
		email: '',
		weight: null,
		age: null,
		sex: null,
		birthday: null,
		password: ''
	},

    routerInfo: ''
}

const mutations = {
	updateField,

	clearParams () {
		state.params = {
			filterBy: null,
			sortBy: null,
			page: 1,
			count: 10
		}
	},

	clearUserForm () {
		state.userForm = {
			facebookId: '',
			name: '',
			email: '',
			weight: null,
			age: null,
			sex: null,
			birthday: null,
			password: ''
		}
	},

	async clearError () {
		state.error = {
			email: '',
			password: '',
			name: '',
			weight: '',
			// age: '',
			birthday: null,
			sex: ''
		}
	},

	setBandList (state, payload) {
		state.bandList = payload
	},

	SET_LIST_LOADING (state, payload) {
		state.listLoading = payload
	}
}

const actions = {
    async getRouterInfo ({ state, dispatch }, payload) {
		state.listLoading = true

		const { data } = await api('get', `/insight/cassia/router-info?id=${payload}`)

		if (data.status !== 200 && data.status !== 204) {
			dispatch('banner/toggleBanner', {
				status: true,
				message: 'error_something_wrong',
				type: 'error'
			}, { root: true })
			state.listLoading = false
			return
		}

		state.routerInfo = data.data

		state.listLoading = false
	},

	async getRouterList ({ state, dispatch }, payload) {
		state.listLoading = true

		const { data } = await api('get', payload)

		if (data.status !== 200 && data.status !== 204) {
			dispatch('banner/toggleBanner', {
				status: true,
				message: 'error_something_wrong',
				type: 'error'
			}, { root: true })
			state.listLoading = false
			return
		}

		state.routerList = data.data

		state.listLoading = false
	},

	async checkPassword ({ state, commit, dispatch }, payload) {
		state.buttonLoading = true
		payload.commit = commit

		const { data, status } = await api('post', '/insight/cassia/router-pass', payload)

		if (!(status && data.status === 200)) {
			state.loginError = data.message
			state.buttonLoading = false
			return
		}

		state.loginError = null
		state.buttonLoading = false
	},

	async getBandList ({ state, dispatch }, payload) {
		// state.listLoading = true

		const { data } = await api('get', `insight/cassia/router-band?router_id=${payload}`)

		if (data.status !== 200 && data.status !== 204) {
			// dispatch('banner/toggleBanner', {
			// 	status: true,
			// 	message: 'error_something_wrong',
			// 	type: 'error'
			// }, { root: true })
			state.listLoading = false
			return
		}

		state.bandList = data.data
		state.listLoading = false
	},

	async loginGuest ({ state, commit, dispatch }, payload) {
		state.buttonLoading = true
		payload.commit = commit

		let endpoint = ''
		if (state.userType === 'facebook') endpoint = '/insight/cassia/connect-fb'
		else endpoint = '/insight/cassia/connect-user'

		const { data, status } = await api('post', endpoint, payload)

		if (!(status && data.status === 200)) {
			state.error = data.errors.message
			state.buttonLoading = false
			return
		}

		/* Get the band index to update */
		const bandItem = state.bandList.filter(x => x.id === data.data[0].id)[0]

		if (bandItem) {
			const responseData = data.data[0]
			bandItem.users = responseData.users
		}

		state.error = null
		state.isLogin = false
		state.buttonLoading = false

		dispatch('banner/toggleBanner', {
			status: true,
			message: 'login_successfully',
			type: 'success'
		}, { root: true })
	},

	async editUser ({ state, commit, dispatch }, payload) {
		state.buttonLoading = true
		payload.commit = commit

		const { data, status } = await api('post', '/insight/cassia/update-profile', payload)

		if (!(status && data.status === 200)) {
			state.error = data.errors.message
			state.buttonLoading = false
			return
		}

		/* Get the band index to update */
		const bandItem = state.bandList.filter(x => x.id === data.data[0].id)[0]

		if (bandItem) {
			const responseData = data.data[0]
			bandItem.users = responseData.users
		}

		state.userType = null
		state.buttonLoading = false

		dispatch('banner/toggleBanner', {
			status: true,
			message: 'user_successfully_updated',
			type: 'success'
		}, { root: true })
	},

	async logout ({ state, commit, dispatch }, payload) {
		payload.form.commit = commit
		state.buttonLoading = true

		const { data, status } = await api('post', '/insight/cassia/disconnect-user', payload.form)

		if (!(status && data.status === 200)) {
			state.buttonLoading = false
			return
		}

		const bandItem = state.bandList.filter(x => x.id === data.data[0].id)[0]
		bandItem.users = data.data[0].users

		dispatch('banner/toggleBanner', {
			status: true,
			message: 'logout_successfully',
			type: 'success'
		}, { root: true })

		state.buttonLoading = false
		state.isLogout = false
	},

	async connectUser ({ state, commit, dispatch }, payload) {
		state.buttonLoading = true
		payload.form.commit = commit

		// const isModalTypeFacebookUser = state.modalType === 'facebookUser'
		// const endpoint = isModalTypeFacebookUser
		// 	? '/insight/cassia/connect-fb'
		// 	: '/insight/cassia/connect-user'

		let endpoint = ''
		switch (payload.modalType) {
		// case 'facebookUser': endpoint = '/insight/cassia/connect-fb'; break
		case 'editUser': endpoint = '/insight/cassia/update-profile'; break
		default : endpoint = '/insight/cassia/connect-user'; break
		}

		const { data, status } = await api('post', endpoint, payload.form)

		if (!(status && data.status === 200)) {
			if (data.errors.message) {
				state.error.email = data.errors.message
			} else if (data.message) {
				state.error.email = data.message
			} else if (data.errors.email && data.errors.email.length) {
				state.error.email = data.errors.email[0]
			}

			// if (state.modalType === 'facebookUser') {
			// 	commit('TOGGLE_BANNER', {
			// 		status: true,
			// 		message: data.message,
			// 		type: 'failed'
			// 	}, { root: true })

			// 	state.modalType = 'userType'
			// }
			// state.isConnecting = false
			state.buttonLoading = false
			return
		}

		/* Get the band index to update */
		const bandItem = state.bandList.filter(x => x.id === data.data[0].id)[0]

		if (bandItem) {
			// const bandItem = state.bands[bandItemIndex]
			const responseData = data.data[0]
			bandItem.users = responseData.users
			dispatch('banner/toggleBanner', {
				status: true,
				message: 'success',
				type: 'success'
			}, { root: true })
		}

		commit('clearUserForm')
		commit('clearError')

		// state.modalType = 'userType'
		state.isLogin = false
		state.buttonLoading = false
	}
}

const getters = {
	getField
}

export default {
	state,
	actions,
	mutations,
	getters,
	namespaced: true
}
